/*eslint-disable*/


export const setPathname = (path) => {
  return {
    type: 'SET_PATHNAME',
    path
  }
}
